import { ATTRIBUTION_MODIFICATIONS_NO } from 'global/constants';
import { StimulusAttribution } from '../stimulus.constants';

export function canShowAttributionModificationDescription(
  attribution: StimulusAttribution | null | undefined
) {
  return (
    attribution?.modificationDescription &&
    attribution.modifications !== ATTRIBUTION_MODIFICATIONS_NO
  );
}
